import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { KybFlowStateService } from '../services/kyb-flow-state.service';
import { KybApiService } from '../services/kyb-api.service';
import { KybProcessStep } from '../interfaces/kyb';

/** Previene navegar a un step que el usuario aun no alcanzo (shownStep > currentStep backend).
 * Si lo intenta, redirige al currentStep. Tambien si no hay processId, manda a /products. */
export function kybStepGuard(step: KybProcessStep): CanActivateFn {
  return async () => {
    const router = inject(Router);
    const kybApi = inject(KybApiService);
    const kybState = inject(KybFlowStateService);

    if (!kybApi.getId()) {
      return router.createUrlTree(['/products']);
    }
    try {
      await kybState.hydrateFromBackend();
    } catch {
      return router.createUrlTree(['/products']);
    }

    const currentStep = kybState.currentStep;
    const steps = kybState.stepsArray;
    if (!currentStep || !steps.length) return true;

    const currentIdx = steps.indexOf(currentStep);
    const targetIdx = steps.indexOf(step);
    if (targetIdx > currentIdx) {
      const currentRoute = kybState.getRouteForStep(currentStep);
      const targetRoute = kybState.getRouteForStep(step);
      // Si current y target comparten la misma ruta (ej. PM SUITE agrupa
      // SHAREHOLDERS y DOCUMENTS en /kyb-pm/documentation), permitimos el
      // acceso: el componente se encarga de avanzar el backend internamente.
      if (currentRoute && targetRoute && currentRoute === targetRoute) return true;
      return currentRoute ? router.createUrlTree([currentRoute]) : true;
    }
    return true;
  };
}
